import { BackendService } from './BackendService';
import { IDashboardResource, IDeviceList } from '@/types/resource.types';

export class DashboardService extends BackendService {

    private _baseUrl: string = '/dashboard';

    public async getDashboard(): Promise<IDashboardResource> {
        let res = await this.jsonClient.get<IDashboardResource>(`${this._baseUrl}`);
        return res.data;
    }
}

export default new DashboardService();
